import * as React from "react";
import {
	Box,
	Container,
	Typography,
	Button,
	Paper,
} from "@mui/material";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import Stack from "@mui/material/Stack";
import { useTranslation } from "react-i18next";
import DateRangeSelector from "../../components/DateRangeSelector";
import { ApiContext } from "../../App";

const Reports = ({ clientInfo, facility, facilities }) => {
	const { t } = useTranslation();

	var earlierDate = new Date();
	earlierDate.setDate(earlierDate.getDate() - 1);
	const [fromDate, setFromDate] = React.useState(earlierDate);
	const [toDate, setToDate] = React.useState(new Date());
	const [timeAggType, setTimeAggType] = React.useState("h");

	React.useEffect(() => {
	
			if ((toDate - fromDate) >=  30*24*3600*1000 && timeAggType === 'h') {
				setTimeAggType('d')
			} 
	
			
		},
			[fromDate, toDate, timeAggType]
		)

	const handleTimeAggTypeChange = (event, newValue) => {
		setTimeAggType(newValue);
	};

	const {readingsApi} = React.useContext(ApiContext)

	const handleDownloadClick = () => {
		readingsApi.getTrendsExcel(
			facility,
			fromDate,
			toDate,
			timeAggType,
			(data) => {
				var url = window.URL.createObjectURL(data);
				var a = document.createElement("a");
				a.href = url;
				a.download = `report_${fromDate.toISOString().split("T")[0]}_${toDate.toISOString().split("T")[0]}.xlsx`;
				document.body.appendChild(a);
				a.click();
				a.remove();
			},
			() => {
				window.alert(t("Couldn't retrieve Excel file."));
			}
		);
	};

	return (
		<Box
			sx={{
				backgroundColor: (theme) => theme.palette.grey[100],
				overflow: "auto",
				height: "calc(100vh - 65px)",
			}}
		>
			<Container sx={{ mt: 4, mb: 4 }}>
				<Paper sx={{ p: 2 }}>
					<Stack
						direction={{ xs: "column", md: "row" }}
						spacing={5}
					>
						<DateRangeSelector
							fromDate={fromDate}
							toDate={toDate}
							onFromDateChange={(newDate) => setFromDate(newDate)}
							onToDateChange={(newDate) => setToDate(newDate)}
							small="true"
						/>
						<Stack
							direction={{ xs: "column", md: "row" }}
							spacing={2}
						>
							<Typography
								component="h2"
								variant="h6"
								color="primary"
							>
								{t("Granularity")}
							</Typography>
							<ToggleButtonGroup
								value={timeAggType}
								exclusive
								size="small"
								onChange={handleTimeAggTypeChange}
							>
								<ToggleButton value="h">{t("H")}</ToggleButton>
								<ToggleButton value="d">{t("D")}</ToggleButton>
								<ToggleButton value="m">{t("M")}</ToggleButton>
								<ToggleButton value="q">{t("Q")}</ToggleButton>
								<ToggleButton value="y">{t("Y")}</ToggleButton>
							</ToggleButtonGroup>
							<Button
								variant="contained"
								size="small"
								onClick={handleDownloadClick}
							>
								{t("Download")}
							</Button>
						</Stack>
					</Stack>
				</Paper>
			</Container>
		</Box>
	);
};

export default Reports;
